import React, { useContext, useState } from "react";
import RelatorioComum from "./TiposDeRelatorios/RelatorioComum";
import RelatorioRural from "./TiposDeRelatorios/RelatorioRural";
import RelatorioLeilaoNegativo from "./TiposDeRelatorios/RelatorioLeilaoNegativo";
import RelatorioExtrajudicial from "./TiposDeRelatorios/RelatorioExtraJudicial";
import RelatorioApartamentoGaragem from "./TiposDeRelatorios/RelatorioApartamentoGaragem";
import RelatorioVagaGaragem from "./TiposDeRelatorios/RelatorioGaragem";
import RelatorioDoisOuMais from "./TiposDeRelatorios/RelatorioDoisOuMais";
export default function App() {
  const tiposRelatorio = [
    "1 - Imóveis em Geral",
    "2 - Imóveis Rurais",
    "3 - Relatório de Leilão Negativo",
    "4 - Extrajudicial",
    "5 - Apartamento + Vaga de Garagem",
    "6 - Vaga de Garagem",
    "7 - Dois imóveis ou Mais",

    // ... outros tipos
  ];

  const [tipoSelecionado, setTipoSelecionado] = useState("");

  const handleChange = (event) => {
    setTipoSelecionado(event.target.value);
  };

  const renderFormulario = () => {
    switch (tipoSelecionado) {
      case "1 - Imóveis em Geral":
        return <RelatorioComum />;
      case "2 - Imóveis Rurais":
        return <RelatorioRural />;
      case "3 - Relatório de Leilão Negativo":
        return <RelatorioLeilaoNegativo />;
      case "4 - Extrajudicial":
        return <RelatorioExtrajudicial />;
      case "5 - Apartamento + Vaga de Garagem":
        return <RelatorioApartamentoGaragem />;
      case "6 - Vaga de Garagem":
        return <RelatorioVagaGaragem />;
      case "7 - Dois imóveis ou Mais":
        return <RelatorioDoisOuMais />;
      // ... outros casos
      default:
        return null;
    }
  };

  return (
    <div className=" w-[100%] mx-auto flex items-center justify-center ">
      <div className="w-[100%] flex-col flex gap-9 items-center justify-center ">
        <h1 className="text-2xl font-semibold tracking-wide">
          Avaliação Relatórios
        </h1>

        <div className="relative w-full max-w-xl">
          <select
            id="tipoRelatorio"
            value={tipoSelecionado}
            onChange={handleChange}
            className="appearance-none w-full px-4 py-3 pr-12 rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-800 dark:text-white placeholder-gray-400 text-base shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 ease-in-out"
          >
            <option value="">Selecione o tipo de relatório</option>
            {tiposRelatorio.map((tipo, index) => (
              <option key={index} value={tipo}>
                {tipo}
              </option>
            ))}
          </select>

          {/* Ícone de seta personalizado */}
          <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none text-gray-400 dark:text-gray-300">
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        </div>
        {renderFormulario()}
      </div>
    </div>
  );
}
